import { NgTemplateOutlet } from '@angular/common';
import type { AfterViewInit, ElementRef } from '@angular/core';
import {
  Component,
  computed,
  inject,
  input,
  signal,
  viewChild,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  ONYX_TABLE_TOOLTIP_DELAY,
  OnyxTooltipDirective,
  OverflowHelper,
} from '@onyx/angular';
import { isArray, isString } from 'lodash';
import type { DictionaryCode } from '../../../enums/dictionary-code';

@Component({
  selector: 'app-string-cell',
  imports: [TranslatePipe, NgTemplateOutlet, OnyxTooltipDirective],
  templateUrl: './string-cell.component.html',
  styleUrl: './string-cell.component.scss',
})
export class StringCellComponent implements AfterViewInit {
  protected readonly overflowHelper = inject(OverflowHelper);

  public readonly value = input<string[] | string | null>();
  public readonly dictionaryCode = input<DictionaryCode>();
  public readonly color = input<'gray' | 'red' | 'transparent'>('transparent');
  public readonly wrap = input(false);

  protected readonly TOOLTIP_DELAY = ONYX_TABLE_TOOLTIP_DELAY;

  protected tooltip = signal<string | undefined>(undefined);

  protected valueAsArray = computed(() => {
    const value = this.value();
    return isArray(value) && value.length !== 0 ? value : false;
  });

  protected valueAsString = computed(() => {
    const value = this.value();
    return isString(value) ? value : false;
  });

  private valueElementRef = viewChild<ElementRef<HTMLElement>>('valueElement');

  public ngAfterViewInit(): void {
    this.tooltip.set(
      this.valueElementRef()?.nativeElement.textContent ?? undefined,
    );
  }
}
